import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  accept() {
    // Set cookie for 30 days
    const expires = new Date()
    expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000)
    document.cookie = `cookie_consent=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`

    this.element.remove()
  }
}
